(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/betslip/betslip-content-rows.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/betslip/betslip-content-rows.js'); 
'use strict';

svs.maltipset.views.BetslipContentRows = Backbone.Marionette.View.extend({
  className: 'maltipset-betslip-rows',
  modelEvents: {
    change: 'modelChange'
  },
  template: function(data) {
    return svs.maltipset.templates.betslip_content_rows(data);
  },
  modelChange: function() {
    var self = this;
    if (!svs.core.detect.feature('ft-betslip-maltipset')) {
      setTimeout(function() {
        self.betslip.changeSize();
      }, 0);
    }
    this.render();
  },
  initialize: function(options) {
    this.betslip = options.betslip;
  }
});

 })(window);